export type LoadingState = number;
export const LoadingStateLoading = 0;
export const LoadingStateHasData = 1;
export const LoadingStateNoData = 2;
